import { ConstantPool } from '@angular/compiler/public_api';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DashboardManagementService } from 'src/app/dashboard/dashboard-management.service';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { NotificationService } from 'src/app/shared/errors/notification.service';
import { IUnitCard, IAVailableUnit } from '../../activity/user-card.interface';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CommonService } from 'src/app/shared/utils/common.service';

@Component({
  selector: 'app-view-all-available-units',
  templateUrl: './view-all-available-units.component.html',
  styleUrls: ['./view-all-available-units.component.scss'],
})
export class ViewAllAvailableUnitsComponent implements OnInit {
  readonly LANG_CONST = LANG_CONST;
  sharedData!: any;
  siteId!: string;
  availableUnits: IUnitCard[] = [];
  subscription: Subscription | undefined;
  canLoad: boolean = false;
  loadingData: boolean = false;
  serverUnitCount: number | undefined;
  cursor: string[] = [''];
  avaialableUnitCount: number | undefined;

  constructor(
    public dialogRef: MatDialogRef<ViewAllAvailableUnitsComponent>,
    private dashboardManagementService: DashboardManagementService,
    @Inject(MAT_DIALOG_DATA) data: any,
    private notificationService: NotificationService,
    public sharedDataService: SharedDataService,
    private router: Router,
    private commonService: CommonService
  ) {
    this.siteId = data?.siteId;
  }
  ngOnInit(): void {
    this.subscription = this.sharedDataService?.currentData?.subscribe(
      (sharedData) => {
        this.sharedData = sharedData;
      }
    );
    this.fetchDashboardUnits([''], false);
  }

  /**
   * @description this function responsible of fetch new DashboardAvailableUnits data
   * @param ev event of scroll
   * @returns void
   */

  onScrollDown(ev: any) {
    if (!(this.canLoad || this.avaialableUnitCount! === this.serverUnitCount!)) {
      this.canLoad = true;
      this.loadingData = false;
      if (this.cursor === null) {
        this.canLoad = false;
        return;
      }
    this.fetchDashboardUnits(this.cursor, true);
    }
  }
  /**
   * @description #fetchDashboardUnits responsible of fetch new DashboardAvailableUnits data
   *               from the API.
   * @param unitId: string
   * @returns void
   */

  fetchDashboardUnits(cursor: string[], hideLoader?: boolean) {
    this.dashboardManagementService
      .getDashboardAvailableUnits(this.siteId, cursor, hideLoader)
      .subscribe({
        next: (res: any) => {
          this.loadingData = false;
          this.canLoad = false;

          this.serverUnitCount = res?.availableUnits?.[0]?.totalCount;

          this.cursor = [...res?.availableUnits?.[0]?.cursor];
          const responseUnits = res?.availableUnits?.[0]?.units || [];
          const transformedUnits = responseUnits?.map((unit: any) => ({
            ...unit,
          }));
          this.availableUnits = [...this.availableUnits, ...transformedUnits];
          this.avaialableUnitCount = this.availableUnits.length || undefined;
        },
        error: (err: Error) => {
          if (window.__dev__) console.log('getDashboardAvailableUnits', err);
          this.notificationService.showError(err?.message);
          this.canLoad = false;
          this.loadingData = false;
        },
      });
  }

  /**
   * Function used as the trackBy function for ngFor directive.
   * It tracks the options in the ngFor loop based on the provided index and option.
   *
   * @param index The index of the current option in the ngFor loop.
   * @param option The current option object in the ngFor loop.
   * @returns The option itself as the unique identifier for tracking.
   */
  trackByOption(index: number, option: any) {
    return option;
  }

  /**
   * @description close modal by the help of dialgue reference
   * @returns void
   */
  closeDialog(): void {
    this.dialogRef?.close();
  }
  /**
   * Handle the click event when accessing a specific resource.
   * @param access - The unit object representing the resource.
   */
  onClickAvailableUnit(unitData: any) {
    // Set the selected building, floor, and access point or unit data
    this.sharedDataService.setAllEntityData(unitData);
    this.closeDialog();
    // Navigate to the site management page
    this.router.navigate(['../site-management']);
  }
}
